module.exports = __webpack_public_path__ + "img/mc-4-3p-off1.58c281e7.gif";